/**
 * Hoja de estilos compartida del modulo Seway Plus Negocios.
 *
 * Se importa desde JS y no desde un bloque <style> de un .vue para que webpack
 * la deduplique: la usan tanto NegociosShell (landing, registro, legales) como
 * las pantallas de autenticacion, que no llevan la carcasa de la landing.
 * Importarla en dos bloques <style> distintos emitiria el CSS dos veces.
 *
 * Todas las reglas del archivo cuelgan de .sp-negocios, asi que nada puede
 * escaparse al resto del ERP.
 */
import './negocios.scss';
